import { render, staticRenderFns } from "./WorkspaceCard.vue?vue&type=template&id=5f974980&"
import script from "./WorkspaceCard.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports